/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The type of the verification method.
 */
export type EcdsaSecp256K1VerificationKey2019Type = 'Multikey' | 'EcdsaSecp256k1VerificationKey2019';
export const EcdsaSecp256K1VerificationKey2019Type = {
    Multikey: 'Multikey',
    EcdsaSecp256K1VerificationKey2019: 'EcdsaSecp256k1VerificationKey2019',
} as const;
